import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  deleteAccount: {
    id: 'accountSettings.deleteAccount.button',
    defaultMessage: 'Request account deletion',
  },
  deleteAccountDialogConfirm: {
    id: 'accountSettings.deleteAccount.dialogConfirm',
    defaultMessage: 'Delete my account',
  },
  deleteAccountDialogHeader: {
    id: 'accountSettings.deleteAccount.dialogHeader',
    defaultMessage: 'We’ll be sad to see you go',
  },
})
